export default {
	// SOLUTIONS
	'early_mobilization': {
		heading: 'Early mobilization',
		description: 'Thanks to our 4-step mobilizaiton program and variety of special features, such as Mobi-Lift handle, Eleganza 4 provides solid support during mobilization process, which is crucial in order to recover sooner.',
		images: [
			'eleganza4/solution--early-mobilization.jpg'
		],
	},
	'safe_patient_moving_and_handling': {
		heading: 'Safe patient moving and handling',
		description: 'Eleganza 4 allows perfect access to the upper part of the patient’s body where most of the critical care treatments take place. These procedures are made easier thanks to our siderails concept, one-button functions and hands-free bed positioning strategy.',
		images: [
			'eleganza4/solution--safe-patient-moving-and-handling.jpg'
		],
	},
	'pressure_injury_prevention': {
		heading: 'Pressure injury prevention',
		description: "The wide range of the passive, hybrid and active LINET mattress portfolio supports individual patient needs regarding injury prevention and therapy. Ergoframe feature then creates more space under patient's pelvis and contributes to greater comfort.",
		images: [
			'eleganza4/solution--pressure-injury-prevention.jpg'
		],
	},
	'falls_prevention': {
		heading: 'Falls prevention',
		description: 'Eleganza 4 bed is equipped with sophisticated functions, such as iBrake or Bed Exit Alarm, that protect the patient in different situations.',
		images: [
			'eleganza4/solution--falls-prevention.jpg'
		],
	},
	'improve_patient_experience': {
		heading: 'Improve patient experience',
		description: "Eleganza 4 is designed to provide relevant support during different clinical needs and facilitate patient care. The variety of available features, like cardiac chair position, set of patient controls or integrated scales, contribute to patient's independence and comfort.",
		images: [
			'eleganza4/solution--improve-patient-experience.jpg'
		],
	},


	// KEY FEATURES
	'safety': {
		heading: 'Safety',
		subExplanations: [
			'idrive',
			'ibrake',
			'siderails_concept',
			'cpr',
			'bed_exit_alarm',
			'night_light',
			'infection_control'
		]
	},
	'idrive': {
		heading: 'i-Drive power & 5th castor',
		description: 'Battery powered wheel in the middle of the bed allows easy manipulation and transportation of the patient. Controller can be placed on headboard or IV poles Drive automatically stops if the hand is removed 5th castor retractable castor helps to keep the direction of the bed in long corridors and also helps with turning of the bed in narrow spaces.',
		images: [
			'eleganza4/1.1.iDRUVE_5thCASTOR.jpg',
		],
		camera: {
			orbit: '-7.848rad 1.28rad 40%',
			target: '0m 60m 30m'
		}
	},
	'ibrake': {
		heading: 'i-Brake',
		description: 'i-Brake automatically engages after 60 seconds of being plugged into electricity providing higher level of patient safety. Neutral position allows easier manipulation of the bed sideways',
		images: [
			'eleganza4/1.2.iBRAKE.jpg'
		],
		camera: {
			orbit: '-6.434rad 1.314rad 40%',
			target: '-50m 30m 0m'
		}
	},
	'siderails_concept': {
		heading: 'Siderails concept',
		description: 'The design of the siderails creates safe environment and reliable support. — Contributes to falls prevention — Minimizes risk of entrapment (in between siderails thanks to constant gap) — Allows placement of passive or active mattress system',
		images: [
			'eleganza4/1.3.SIDERAILS-CONCEPT.jpg'
		],
		camera: {
			orbit: '3.095rad 1.498rad 40%',
			target: '-50m 75m 20m'
		}
	},
	'cpr': {
		heading: 'CPR',
		description: 'Set of CPR features qucikly repositions bed in critical situations. CPR button - bed flatens, goes into lowest position. CPR handle – quickly lowers backrest.',
		images: [
			'eleganza4/1.4.CPR.jpg'
		],
		camera: {
			orbit: '-6.434rad 1.469rad 40%',
			target: '-40m 80m -70m'
		}
	},
	'bed_exit_alarm': {
		heading: 'Bed exit alarm',
		description: 'Bed Exit Monitoring system monitors patient´s presence in bed and triggers alarms based on defined zone. Inner zone - triggers alarm when patient is moving or going to leave. Outer zone - trigger alarms when patient left the bed.',
		images: [
			'eleganza4/1.5.BED-EXIT-ALARM.jpg'
		],
		camera: {
			orbit: '-6.434rad 1.469rad 40%',
			target: '-40m 80m -70m'
		}
	},
	'night_light': {
		heading: 'Night light',
		description: 'The light function supports better patient orientation at night and can provide a feeling of safety.',
		images: [
			'eleganza4/1.6.NIGHT-LIGHT.jpg'
		],
		camera: {
			orbit: '-6.273rad 1.634rad 40%',
			target: '0m 0m 0m'
		}
	},
	'infection_control': {
		heading: 'Infection control',
		description: 'Innovative column solution and seamless design enables efficient infection control',
		images: [
			'eleganza4/1.7.INFECTION-CONTROL.jpg'
		],
		camera: {
			orbit: '-6.434rad 1.314rad 40%',
			target: '-50m 30m 0m'
		}
	},
	'mobilization': {
		heading: 'Mobilization',
		subExplanations: [
			'mobi_lift',
			'one_touch_mobilization_button',
			'head_of_board_autostop'
		]
	},
	'mobi_lift': {
		heading: 'Mobi-lift',
		description: 'Patient can hold onto and adjust the height of the bed through the Mobi-Lift handle to easily stand up in the last step of mobilisation. Foldable handle with integrated up and down control placed on the side of the bed.',
		images: [
			'eleganza4/2.1.+MOBI-LIFT+HANDLE.jpg'
		],
		camera: {
			orbit: '-3.153rad 1.527rad 40%',
			target: '80m 65m 0m'
		}
	},
	'one_touch_mobilization_button': {
		heading: 'One-Touch mobilization button',
		description: 'Mobilization button allows reaching the optimal position for mobilization with a press of a single button.',
		images: [
			'eleganza4/mobilization-button.jpg'
		],
		camera: {
			orbit: '-3.086rad 1.541rad 20%',
			target: '-50m 80m 90m'
		}
	},
	'head_of_board_autostop': {
		heading: 'Head-of-board auto stop at 30°/ 45°',
		description: 'Head-of-board automatically stops at 30° and 45° allowing paying maximum attention to the patient.',
		images: [
			'eleganza4/HOBautomaticstop.jpg'
		],
		camera: {
			orbit: '-3.086rad 1.541rad 20%',
			target: '-50m 80m 90m'
		}
	},
	'controls': {
		heading: 'Controls',
		subExplanations: [
			'nurse_control_panel',
			'foot_controls',
			'attendant_control_panel_acp',
			'patient_controls'
		]
	},
	'nurse_control_panel': {
		heading: 'iBoard & nurse control panel',
		description: 'The control panel is easily accessible, and displayed icons are simple to follow. Most of the positioning and emergency functions are set at the touch of one button.',
		images: [
			'eleganza4/3.1.+iBOARD+_+NURSE+CONTROL+PANEL.jpg'
		],
		camera: {
			orbit: '-3.086rad 1.541rad 20%',
			target: '-50m 80m 90m'
		}
	},
	'foot_controls': {
		heading: 'Foot controls',
		description: 'Foot controls placed on bed undercarriage allowing hands free height adjustment.',
		images: [
			'eleganza4/3.2.+FOOT+CONTROLS.jpg'
		],
		camera: {
			orbit: '-3.13rad 1.556rad 40%',
			target: '30m 20m 70m'
		}
	},
	'attendant_control_panel_acp': {
		heading: 'Attendant control panel (ACP)   ',
		description: 'Dedicated attendant nurse control panel allows the control the key features from nearby surroundings of the bed.',
		images: [
			'eleganza4/3.3.+ACP.jpg'
		]
	},
	'patient_controls': {
		heading: 'Patient controls',
		description: 'Set of patient controls integrated in side rails for basic adjustment of the bed positions. Hand controller provides further comfort to the patient, incl. night light.',
		images: [
			'eleganza4/3.4.+PATIENT+CONTROLS-a.jpg',
			'eleganza4/3.4.+PATIENT+CONTROLS-b.jpg'
		],
		camera: {
			orbit: '-3.537rad 1.256rad 20%',
			target: '0m 80m 90m'
		}
	},
	'comfort': {
		heading: 'Comfort',
		subExplanations: [
			'x-ray_cassette_holder',
			'bed_extension',
			'ergoframe',
			'integrated_scales',
			'bed_positioning'
		]
	},
	'x-ray_cassette_holder': {
		heading: 'X-RAY Cassette holder',
		description: 'Thanks to the X-ray translucent mattress and special bed construction, the chest X-ray can be performed without any need to move the patient.',
		images: [
			'eleganza4/4.1.+X-RAY.jpg'
		],
		camera: {
			orbit: '-9.379rad 1.493rad 40%',
			target: '-50m 50m 0m'
		}
	},
	'bed_extension': {
		heading: 'Bed extension',
		description: 'Mechanical bed extension allows to extend the bed for up to 22 cm.',
		images: [
			'eleganza4/4.2.+BED+EXTENSION.jpg'
		],
		camera: {
			orbit: '-3.958rad 1.532rad 60%',
			target: '-20m 65m 90m'
		}
	},
	'ergoframe': {
		heading: 'Ergoframe',
		description: 'System causing enlargement of the space between the back and thigh part during their positioning for prevention of preassure injuries.',
		images: [
			'eleganza4/4.3.+ERGOFRAME.jpg'
		]
	},
	'integrated_scales': {
		heading: 'Integrated scales',
		description: "Integrated scales allow easy meassurement of the patient's weight. The control panel showing the value is integrated in the upper siderail, easy to access and follow.",
		images: [
			'eleganza4/4.4.+INTEGRATED+SCALES.jpg'
		],
		camera: {
			orbit: '-9.379rad 1.493rad 40%',
			target: '-80m 80m 0m'
		}
	},
	'bed_positioning': {
		heading: 'Bed positioning',
		description: 'Using nurse control panel, foot controls or attendant control panel the bed can be easily repositioned to any of the standard or advanced position. For the key position one-button positioning function is available. Backrest stops automatically at 30° and 45° angle.',
		images: [
			'eleganza4/4.5.+BED+POSITIONING-a.jpg',
			'eleganza4/4.5.+BED+POSITIONING-b.jpg',
			'eleganza4/4.5.+BED+POSITIONING-c.jpg',
			'eleganza4/4.5.+BED+POSITIONING-d.jpg',
			'eleganza4/4.5.+BED+POSITIONING-e.jpg',
			'eleganza4/4.5.+BED+POSITIONING-f.jpg',
			'eleganza4/4.5.+BED+POSITIONING-g.jpg',
			'eleganza4/4.5.+BED+POSITIONING-h.jpg',
		]
	},
}
